<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M20.12 7.88v16c0 1.791 1.235 2.787 2.546 2.787 1.212 0 2.545-.848 2.545-2.788V8.001c0-1.64-1.212-2.667-2.545-2.667S20.12 6.467 20.12 7.879zM13.454 16v7.88c0 1.791 1.235 2.788 2.545 2.788 1.212 0 2.546-.849 2.546-2.788v-7.758c0-1.64-1.212-2.667-2.546-2.667-1.333 0-2.545 1.133-2.545 2.546zM9.333 26.668a2.546 2.546 0 10-.002-5.092 2.546 2.546 0 00.002 5.092z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'brandGoogleAnalyticsFilled'
}
</script>
